import React, { useContext } from 'react';
import TimerContext from '~/context/timerContext';

import { Container } from './styles';

const Time = () => {
  const timerContext = useContext(TimerContext);
  const { time } = timerContext;

  return (
    <Container>
      <h1>
        {(`0${Math.floor(time / 60).toString()}`).slice(-2)}
        :
        {(`0${(time % 60).toString()}`).slice(-2)}
      </h1>
    </Container>
  );
};

export default Time;
